import { interfaces } from "inversify";
import { ApiServiceBinder as TelemetryBinder } from "./generated/Telemetry/ApiServiceBinder";
import { ApiServiceBinder as ConfigurationServiceBinder } from "./generated/Configuration/ApiServiceBinder";
import { ApiServiceBinder as FeaturesBinder } from "./generated/Features/ApiServiceBinder";
import { ApiServiceBinder as FederatedAuthBinder } from "./generated/FederatedAuth/ApiServiceBinder";

import { TwilsockAdapter } from "./TwilsockAdapter/TwilsockAdapter";
import { twilsockAdapterRTTI, httpAdapterRTTI } from "./backend.rtti";
import { TwilsockAdapterImpl } from "./TwilsockAdapter/TwilsockAdapterImpl";
import { HttpAdapter } from "./HttpAdapter/HttpAdapter";
import { HttpAdapterImpl } from "./HttpAdapter/HttpAdapterImpl";

export function withContainer(container: interfaces.Container): void {
    container.bind<TwilsockAdapter>(twilsockAdapterRTTI).to(TwilsockAdapterImpl).inSingletonScope();
    container.bind<HttpAdapter>(httpAdapterRTTI).to(HttpAdapterImpl).inSingletonScope();

    TelemetryBinder.with(container);
    ConfigurationServiceBinder.with(container);
    FeaturesBinder.with(container);
    FederatedAuthBinder.with(container);
}
